import { render, staticRenderFns } from "./AppSidePanel.vue?vue&type=template&id=25de827e"
import script from "./AppSidePanel.vue?vue&type=script&lang=js"
export * from "./AppSidePanel.vue?vue&type=script&lang=js"
import style0 from "./AppSidePanel.vue?vue&type=style&index=0&id=25de827e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports